import apiClient from '../axios.js';

export const tagService = {
  /**
   * 查詢標籤列表
   * @param {Object} params - 查詢參數
   * @param {boolean} params.isActive - 是否啟用（選填）
   * @param {string} params.tagSource - 標籤來源（選填）
   * @returns {Promise<Object>} 標籤列表
   */
  getTags: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.tagSource) queryParams.append('tagSource', params.tagSource);

    const queryString = queryParams.toString();
    const url = `/tags${queryString ? `?${queryString}` : ''}`;
    const response = await apiClient.get(url);
    return response;
  },

  /**
   * 查詢會員標籤
   * @param {string} memberId - 會員 ID
   * @returns {Promise<Object>} 會員標籤列表
   */
  getMemberTags: async (memberId) => {
    const response = await apiClient.get(`/members/${memberId}/tags`);
    return response;
  },

  /**
   * 新增標籤到會員
   * @param {string} memberId - 會員 ID
   * @param {string} tagId - 標籤 ID
   * @returns {Promise<Object>} 新增結果
   */
  addTagToMember: async (memberId, tagId) => {
    const response = await apiClient.post(`/members/${memberId}/tags`, {
      tagId
    });
    return response;
  },

  /**
   * 移除會員標籤
   * @param {string} memberId - 會員 ID
   * @param {string} tagId - 標籤 ID
   * @returns {Promise<Object>} 移除結果
   */
  removeTagFromMember: async (memberId, tagId) => {
    const response = await apiClient.delete(`/members/${memberId}/tags/${tagId}`);
    return response;
  },

  /**
   * 查詢標籤詳情
   * @param {string} tagId - 標籤 ID
   * @returns {Promise<Object>} 標籤詳情
   */
  getTag: async (tagId) => {
    const response = await apiClient.get(`/tags/${tagId}`);
    return response;
  },

  /**
   * 建立標籤
   * @param {Object} tagData - 標籤資料
   * @returns {Promise<Object>} 建立結果
   */
  createTag: async (tagData) => {
    const response = await apiClient.post('/tags', tagData);
    return response;
  },

  /**
   * 更新標籤
   * @param {string} tagId - 標籤 ID
   * @param {Object} tagData - 標籤資料
   * @returns {Promise<Object>} 更新結果
   */
  updateTag: async (tagId, tagData) => {
    const response = await apiClient.put(`/tags/${tagId}`, tagData);
    return response;
  },

  /**
   * 獲取標籤的會員關聯數量
   * @param {string} tagId - 標籤 ID
   * @returns {Promise<Object>} 會員關聯數量
   */
  getMemberTagCount: async (tagId) => {
    const response = await apiClient.get(`/tags/${tagId}/member-count`);
    return response;
  },

  /**
   * 刪除標籤
   * @param {string} tagId - 標籤 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deleteTag: async (tagId) => {
    const response = await apiClient.delete(`/tags/${tagId}`);
    return response;
  },

  /**
   * 檢查系統內建標籤是否齊全
   * @returns {Promise<Object>} { complete, missing }
   */
  getBuiltInStatus: async () => {
    const response = await apiClient.get('/tags/built-in');
    return response;
  },

  /**
   * 補齊缺少的系統內建標籤與規則
   * @returns {Promise<Object>} 補齊後的狀態
   */
  createBuiltInTags: async () => {
    const response = await apiClient.post('/tags/built-in');
    return response;
  }
};
